import { z } from 'zod'
import { createValidator } from '@mc/form-utils'
import { EMAIL_CAPTURE_I18N } from '../constants'
import { i18nInstance } from '../i18n/i18nInstance'

const t = i18nInstance.getFixedT(null, EMAIL_CAPTURE_I18N)

const baseSchema = z.object({
  email: z
    .string({ required_error: t('email.required') })
    .min(1, t('email.required'))
    .email(t('email.invalid')),
})

const gdprConsentSchema = z.object({
  gdprConsent: z.literal(true, {
    errorMap: () => ({ message: t('gdprCheckbox.required') }),
  }),
})

export const getEmailFormValidator = ({
  isGdprConsentRequired,
}: {
  isGdprConsentRequired?: boolean
}) => {
  const schema = isGdprConsentRequired
    ? baseSchema.merge(gdprConsentSchema)
    : baseSchema

  return createValidator(schema)
}
